export const getLanguageNativeName = (lang: string): string => {
    // 📘 docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames#language_display_names
    const languageNames = new Intl.DisplayNames([lang], { type: 'language' });
    return capitalize(languageNames.of(lang) || lang);
};
